import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { DocumentModerationPayload, DocumentModerationResponse } from '@/models/documents/document.model';

export class CreateDocumentModerationRequest extends ApiResourceMethod<BaseResponse<DocumentModerationResponse>> {
  public perform({
    playerId,
    documentModerationAction,
    whitelabelSlug,
  }: DocumentModerationPayload): Promise<BaseResponse<DocumentModerationResponse>> {
    return this.performer.request(
      {
        url: `${whitelabelSlug}/documentModeration/${playerId}`,
        data: { action: documentModerationAction },
      },
    );
  }
}
